/* Gleva · Direction B · proof media JS: Product videos (window.gvbUgcVideos) + Before & after (window.gvbBeforeAfter).
   Port of final-b2/_src/sp2/ugc-video.js + before-after.js (sp2/media SPEC §1.4, §2.3). ES module, loaded by the two
   sections (a module URL runs once per page even when both sections include it). Self-inits; re-inits on
   shopify:section:load. Theme wiring: Add to bag uses GVB.cartAdd (gvb.js: /cart/add.js like Impact's ProductForm,
   then variant:add + cart:change, toast); a failed add (sold out) turns the button into a disabled "Sold out".
   "View bag" closes the player and opens Impact's #cart-drawer. "pick" checks .tiers .tier[data-tier] input.
   Cards come from section blocks (data-block-id) or the product's own video list (data-source="product", no block
   id); both carry the same data-src/-preview/-src-full/-poster/-caption and optional data-ai="1". Nothing about who
   made a video is read or shown; the only label is the "AI-generated" chip when data-ai="1". */

/* ======================= Product videos ======================= */
(function () {
  'use strict';
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var conn = navigator.connection || {};
  var REDUCE = mq('(prefers-reduced-motion: reduce)');
  /* data saver, reduced data, or a 2G/3G connection: posters only (the player still plays on tap) */
  var SAVE = !!conn.saveData || mq('(prefers-reduced-data: reduce)') || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  /* Sources (snippets/gvb-media-video-src): data-preview = the 480p MP4 for card previews, data-src = the ≤ 720p MP4
     for the player, data-src-full = Shopify's top MP4 (the only file Liquid lists). The 480p/720p names are derived
     from Shopify's rendition ladder, so a derived file that fails to load falls back to data-src-full once.
     Card previews loop the first PREVIEW_S seconds. Chrome still buffers the rest of a short clip while it plays,
     so a preview is detached (download stopped, decoder freed) as soon as it stops. */
  var PREVIEW_S = 6;
  var srcOf = function (c) { return c.dataset.src || c.dataset.srcFull; };
  var previewOf = function (c) { return c.dataset.preview || srcOf(c); };
  /* once per element: on a load error of a derived file, switch to the top MP4 and carry on */
  function fallback(v, c, after) {
    if (v._ugvFb) return; v._ugvFb = true;
    v.addEventListener('error', function () {
      var full = c() && c().dataset.srcFull, cur = v.getAttribute('src');
      if (!cur || !full || cur === full) return;
      v.setAttribute('src', full); v.load(); if (after) after();
    });
  }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- page-wide preview coordinator */
  var P = { cards: [], ratio: new Map(), live: null, hover: null, blocked: false, open: false, io: null, raf: 0 };
  var autoOK = function () { return !REDUCE && !SAVE && !P.blocked && !P.open && !document.hidden; };

  function stopPreview(c) {
    if (!c) return;
    var v = $('.ugv-prev', c);
    c.classList.remove('is-live');
    if (v) {
      if (!v.paused) v.pause();
      if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); }   /* stop the download, free the decoder */
    }
    if (P.live === c) P.live = null;
  }
  function startPreview(c) {
    if (P.live === c) return;
    stopPreview(P.live);
    var v = $('.ugv-prev', c);
    if (!v) return;
    fallback(v, function () { return c; }, function () { if (P.live === c) v.play().catch(function () {}); });
    if (!v.getAttribute('src')) { v.setAttribute('src', previewOf(c)); v.preload = 'auto'; }
    v.muted = true;
    P.live = c;
    var pr = v.play();
    /* only a refused autoplay (Low Power Mode, policy) switches previews off for the session; a load error is left
       to the fallback (top MP4) and costs only that card its preview */
    if (pr && pr.catch) pr.catch(function (e) { if (P.live === c && e && e.name === 'NotAllowedError') { stopPreview(c); P.blocked = true; } });
    if (!v._ugvBound) {
      v._ugvBound = true;
      v.addEventListener('playing', function () { if (P.live === c) c.classList.add('is-live'); });
      v.addEventListener('timeupdate', function () {
        var bar = $('.ugv-bar i', c), span = Math.min(PREVIEW_S, v.duration || PREVIEW_S);
        if (v.currentTime >= span) { v.currentTime = 0; }
        if (bar && span) bar.style.setProperty('--p', Math.min(1, v.currentTime / span).toFixed(3));
      });
    }
  }
  function choose() {
    P.raf = 0;
    if (!autoOK()) { stopPreview(P.live); return; }
    var best = null, bestLeft = Infinity, bestTop = Infinity;
    P.cards = P.cards.filter(function (c) { return c.isConnected; });
    if (P.hover && P.hover.isConnected && (P.ratio.get(P.hover) || 0) >= 0.6) best = P.hover;
    else P.cards.forEach(function (c) {
      if (!c.isConnected || (P.ratio.get(c) || 0) < 0.6) return;
      var r = c.getBoundingClientRect();
      if (r.top < bestTop - 40 || (Math.abs(r.top - bestTop) <= 40 && r.left < bestLeft)) { best = c; bestLeft = r.left; bestTop = r.top; }
    });
    if (best) startPreview(best); else stopPreview(P.live);
  }
  var schedule = function () { if (!P.raf) P.raf = requestAnimationFrame(choose); };
  document.addEventListener('visibilitychange', function () { if (document.hidden) stopPreview(P.live); else schedule(); });

  /* buy-box tier radio for a "pick" action (gvb-tier-row: fieldset.tiers > label.tier[data-tier] > input) */
  function tierInput(v) {
    if (!v) return null;
    var esc = window.CSS && CSS.escape ? CSS.escape(v) : v;
    return document.querySelector('.tiers .tier[data-tier="' + esc + '"] input, .bb .tier[data-tier="' + esc + '"] input');
  }

  /* ---------------------------------------------------------------- player */
  var isAI = function (c) { return !!c && c.dataset.ai === '1'; };

  function Player(sec) {
    var dlg = $('[data-ugv-player]', sec);
    var stage = $('[data-ugv-stage]', dlg), media = $('[data-ugv-media]', dlg);
    var video = $('[data-ugv-video]', dlg), poster = $('[data-ugv-poster]', dlg), bg = $('[data-ugv-bg]', dlg);
    var segsBox = $('[data-ugv-segs]', dlg), toggle = $('[data-ugv-toggle]', dlg), soundBtn = $('[data-ugv-sound]', dlg);
    var hint = $('[data-ugv-hint]', dlg), live = $('[data-ugv-live]', dlg);
    var prevBtns = $$('[data-ugv-prev]', dlg), nextBtns = $$('[data-ugv-next]', dlg);
    var cards = $$('[data-ugv-card]', sec);
    var S = { i: 0, sound: true, raf: 0, swiped: false, lastNav: 0, wheel: 0, hintT: 0, opener: null };
    fallback(video, function () { return dlg.open ? cards[S.i] : null; }, function () { play(); });

    function segs() {
      segsBox.innerHTML = '';
      cards.forEach(function () { var s = document.createElement('span'); s.className = 'ugv-seg'; s.appendChild(document.createElement('i')); segsBox.appendChild(s); });
    }
    function paintSegs(p) {
      $$('.ugv-seg i', segsBox).forEach(function (el, k) { el.style.setProperty('--p', k < S.i ? 1 : k > S.i ? 0 : p); });
    }
    function tick() {
      S.raf = 0;
      if (video.duration) paintSegs(Math.min(1, video.currentTime / video.duration));
      if (!video.paused && !video.ended) S.raf = requestAnimationFrame(tick);
    }
    function setState(k) {
      ['is-paused', 'is-ended', 'is-waiting'].forEach(function (c) { stage.classList.toggle(c, c === 'is-' + k); });
      toggle.setAttribute('aria-label', k === 'ended' ? 'Play again' : k === 'paused' ? 'Play video' : 'Pause video');
    }
    function setSound(on, announce) {
      S.sound = on; video.muted = !on;
      soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', on ? 'Sound on. Turn sound off' : 'Sound off. Turn sound on');
      if (on) { hint.hidden = true; clearTimeout(S.hintT); }
      if (announce) live.textContent = on ? 'Sound on' : 'Sound off';
    }
    function play() {
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function (e) {
        if (e && e.name === 'NotAllowedError' && !video.muted) {
          setSound(false);
          hint.hidden = false; clearTimeout(S.hintT); S.hintT = setTimeout(function () { hint.hidden = true; }, 3200);
          video.play().catch(function () { setState('paused'); });
        } else if (e && e.name !== 'AbortError') setState('paused');
      });
    }
    function load(i, dir) {
      S.i = (i + cards.length) % cards.length;
      var c = cards[S.i];
      stage.classList.remove('has-frame', 'is-in-next', 'is-in-prev');
      if (dir && !REDUCE) { void stage.offsetWidth; stage.classList.add(dir > 0 ? 'is-in-next' : 'is-in-prev'); }
      [poster, bg].forEach(function (im) { if (!im) return; if (c.dataset.poster) im.src = c.dataset.poster; else im.removeAttribute('src'); });
      /* the header shows nothing unless the video has an AI-made presenter */
      var ai = isAI(c), chip = $('[data-ugv-chip]', dlg);
      if (chip) chip.hidden = !ai;
      var cap = c.dataset.caption || '';
      $('[data-ugv-cap]', dlg).textContent = cap;
      var slot = $('[data-ugv-prod]', dlg), tpl = $('template[data-ugv-pc]', c);
      slot.innerHTML = '';
      if (tpl) slot.appendChild(tpl.content.cloneNode(true));
      prevBtns.forEach(function (b) { b.disabled = S.i === 0; }); nextBtns.forEach(function (b) { b.disabled = S.i === cards.length - 1; });
      paintSegs(0);
      video.pause();
      video.src = srcOf(c);
      video.muted = !S.sound;
      setState('waiting');
      play();
      cap = cap.replace(/[\s.]+$/, '');
      live.textContent = 'Video ' + (S.i + 1) + ' of ' + cards.length + (ai ? ', AI-generated presenter' : '') + (cap ? ': ' + cap : '') + '.';
    }
    function go(d) {
      var j = S.i + d;
      if (j < 0 || j >= cards.length) return;
      S.lastNav = Date.now();
      load(j, d);
    }
    function open(i) {
      stopPreview(P.live); P.open = true;
      S.opener = cards[i];
      segs();
      document.documentElement.classList.add('ugv-lock');
      document.documentElement.style.overflow = 'hidden';
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      load(i, 0);
      toggle.focus({ preventScroll: true });
    }
    function close() {
      video.pause(); video.removeAttribute('src'); video.load();
      cancelAnimationFrame(S.raf);
      if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    }
    dlg.addEventListener('close', function () {
      P.open = false;
      document.documentElement.classList.remove('ugv-lock');
      document.documentElement.style.overflow = '';
      video.pause(); video.removeAttribute('src');
      /* return to the card of the video you were on (scroll it into the rail, then focus it) */
      var c = cards[S.i], btn = c && $('[data-ugv-open]', c);
      if (btn) {
        var rail = c.parentElement;
        if (rail && rail.scrollWidth > rail.clientWidth) {
          var r = c.getBoundingClientRect(), rr = rail.getBoundingClientRect();
          if (r.left < rr.left || r.right > rr.right) rail.scrollLeft += r.left - rr.left - parseFloat(getComputedStyle(rail).scrollPaddingLeft || 0);
        }
        btn.focus({ preventScroll: false });
      }
      schedule();
    });

    video.addEventListener('playing', function () { stage.classList.add('has-frame'); setState('playing'); if (!S.raf) S.raf = requestAnimationFrame(tick); });
    video.addEventListener('waiting', function () { setState('waiting'); });
    video.addEventListener('pause', function () { if (!video.ended && dlg.open && video.getAttribute('src')) setState('paused'); });
    video.addEventListener('ended', function () {
      paintSegs(1);
      if (!REDUCE && S.i < cards.length - 1) go(1); else setState('ended');
    });

    toggle.addEventListener('click', function () {
      if (S.swiped) { S.swiped = false; return; }
      if (video.ended || stage.classList.contains('is-ended')) { video.currentTime = 0; play(); return; }
      if (video.paused) play(); else video.pause();
    });
    soundBtn.addEventListener('click', function () { setSound(!S.sound, true); if (video.paused && !video.ended) play(); });
    prevBtns.forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
    nextBtns.forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    $('[data-ugv-close]', dlg).addEventListener('click', close);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    /* a click on the bare backdrop area (desktop, outside the stage and controls) closes */
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('.ugv-pl-bg')) close(); });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]), a[href]:not([tabindex="-1"])', dlg).filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
        if (f.length) {
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && (document.activeElement === last || !dlg.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
        }
        return;
      }
      if (/^(INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) return;
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowRight' || k === 'PageDown') { e.preventDefault(); go(1); }
      else if (k === 'ArrowUp' || k === 'ArrowLeft' || k === 'PageUp') { e.preventDefault(); go(-1); }
      else if (k === 'm' || k === 'M') { e.preventDefault(); setSound(!S.sound, true); }
      else if ((k === 'k' || k === 'K' || (k === ' ' && e.target !== toggle && !/^(BUTTON|A)$/.test(e.target.tagName)))) { e.preventDefault(); toggle.click(); }
    });

    /* swipe up = next, swipe down = previous (a tap still toggles play) */
    var sy = 0, sx = 0, st = 0, tracking = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.ugv-pc, .ugv-pl-hd button, .ugv-pl-nav')) return;
      tracking = true; sy = e.clientY; sx = e.clientX; st = Date.now();
    });
    stage.addEventListener('pointerup', function (e) {
      if (!tracking) return; tracking = false;
      var dy = e.clientY - sy, dx = e.clientX - sx;
      if (Math.abs(dy) > 48 && Math.abs(dy) > Math.abs(dx) * 1.2 && Date.now() - st < 900) {
        S.swiped = true; setTimeout(function () { S.swiped = false; }, 400);
        go(dy < 0 ? 1 : -1);
      } else if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        S.swiped = true; setTimeout(function () { S.swiped = false; }, 400);
        go(dx < 0 ? 1 : -1);
      }
    });
    stage.addEventListener('pointercancel', function () { tracking = false; });
    dlg.addEventListener('wheel', function (e) {
      if (e.target.closest('.ugv-pc')) return;
      e.preventDefault();
      S.wheel += e.deltaY;
      if (Date.now() - S.lastNav > 600 && Math.abs(S.wheel) > 60) { go(S.wheel > 0 ? 1 : -1); S.wheel = 0; }
      clearTimeout(S.wt); S.wt = setTimeout(function () { S.wheel = 0; }, 200);
    }, { passive: false });

    /* product card actions inside the player */
    dlg.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ugv-add]');
      if (add) {
        var d = add.dataset, c = cards[S.i];
        var thumbImg = $('.ugv-pc-th img', dlg);
        var detail = { variantId: d.variantId || null, qty: 1, name: d.name, variant: d.variant || '', price: Number(d.price), thumb: thumbImg ? thumbImg.currentSrc || thumbImg.src : '', source: 'ugc-video', ai: isAI(c) };
        if (add.disabled || add.getAttribute('aria-busy') === 'true') return;
        sec.dispatchEvent(new CustomEvent('gvb:add-to-bag', { bubbles: true, detail: detail }));
        var ok = $('[data-ugv-pc-ok]', dlg), meta = $('[data-ugv-pc-meta]', dlg);
        var done = function () {
          add.removeAttribute('aria-busy');
          add.classList.add('is-added');
          if (ok) { ok.hidden = false; if (meta) meta.hidden = true; }
          live.textContent = d.name + ' added to bag.';
          clearTimeout(add._t); add._t = setTimeout(function () { add.classList.remove('is-added'); }, 1600);
        };
        /* GVB.cartAdd rejects on any failure (422 sold out or cart limit, 429, offline). Only a sold-out answer
           disables the button; anything else keeps it usable and says so, so the player never claims "Sold out"
           for a network error. */
        var fail = function (err) {
          add.removeAttribute('aria-busy');
          var m = (err && err.message) || '';
          if (/sold out|out of stock|no longer available|unavailable/i.test(m)) {
            add.disabled = true; add.classList.add('is-soldout');
            add.textContent = 'Sold out';
            live.textContent = d.name + ' is sold out.';
            return;
          }
          var say = m && !/json|token|fetch|network|load failed/i.test(m) ? m : 'Could not add to bag. Please try again.';
          live.textContent = say;
          if (meta) {
            clearTimeout(meta._t);
            if (meta._orig == null) meta._orig = meta.textContent;
            meta.textContent = say; meta.classList.add('is-err');
            meta._t = setTimeout(function () { meta.textContent = meta._orig; meta.classList.remove('is-err'); }, 4000);
          }
        };
        var GV = window.GVB || window.G;
        if (GV && GV.cartAdd && detail.variantId) {
          add.setAttribute('aria-busy', 'true');
          GV.cartAdd([{ id: Number(detail.variantId), quantity: 1 }], { name: detail.name, variant: detail.variant, price: detail.price, thumb: detail.thumb, source: add }).then(done, fail);
        } else if (window.G && window.G.addToBag) { window.G.addToBag(detail); done(); }
        return;
      }
      var bag = e.target.closest('[data-ugv-bag]');
      if (bag) {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') { e.preventDefault(); close(); drawer.show(); }
        return;
      }
      var pick = e.target.closest('[data-ugv-pick]');
      if (pick) {
        var t = tierInput(pick.dataset.ugvPick);
        if (!t) return;                                    /* not on this product's page: follow the link */
        e.preventDefault(); close();
        t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true }));
        var box = t.closest('.tiers') || t;
        box.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      }
    });

    return { open: open, close: close, go: go, state: S, dlg: dlg, video: video };
  }

  /* ---------------------------------------------------------------- init */
  function initSection(sec) {
    if (sec._ugv) return sec._ugv;
    var cards = $$('[data-ugv-card]', sec);
    if (!cards.length) return null;
    var pl = Player(sec);
    cards.forEach(function (c, i) {
      $('[data-ugv-open]', c).addEventListener('click', function () { pl.open(i); });
      if (FINE && !sec.hasAttribute('data-ugv-no-previews')) {
        c.addEventListener('mouseenter', function () { P.hover = c; schedule(); });
        c.addEventListener('mouseleave', function () { if (P.hover === c) P.hover = null; schedule(); });
      }
      /* card row link that picks a tier on this page (e.g. the kit) */
      var pick = $('.ugv-prod[data-ugv-pick]', c);
      if (pick) pick.addEventListener('click', function (e) {
        var t = tierInput(pick.dataset.ugvPick);
        if (!t) return;
        e.preventDefault(); t.checked = true; t.dispatchEvent(new Event('change', { bubbles: true }));
        (t.closest('.tiers') || t).scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      });
      if (sec.hasAttribute('data-ugv-no-previews')) return;
      P.cards.push(c);
      if (P.io) P.io.observe(c.querySelector('.ugv-open'));
    });
    var rail = $('.ugv-list', sec);
    if (rail) {
      rail.addEventListener('scroll', function () { clearTimeout(rail._t); rail._t = setTimeout(schedule, 120); }, { passive: true });
      /* arrows only when the rail actually overflows */
      var fit = function () { sec.classList.toggle('is-fit', rail.scrollWidth <= rail.clientWidth + 4); };
      fit(); window.addEventListener('resize', fit);
    }
    sec._ugv = pl;
    return pl;
  }

  function init(root) {
    if (!P.io && 'IntersectionObserver' in window) {
      P.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { P.ratio.set(e.target.closest('[data-ugv-card]'), e.isIntersecting ? e.intersectionRatio : 0); });
        schedule();
      }, { threshold: [0, 0.3, 0.6, 0.8, 1] });
    }
    $$('[data-ugv]', root || document).forEach(initSection);
    return { stop: function () { stopPreview(P.live); }, choose: choose, P: P, reduce: REDUCE, saveData: SAVE };
  }

  window.gvbUgcVideos = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Shopify theme editor: re-init a re-rendered section */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-ugv]', e.target).forEach(function (s) { if (s._ugv) s._ugv.close(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var c = e.target.closest && e.target.closest('[data-ugv-card]');
    if (c) c.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();


/* ======================= Before & after ======================= */
(function () {
  'use strict';
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function Frame(f) {
    var r = $('[data-bae-range]', f), anim = 0, touched = false;
    function set(v, fromRange) {
      v = Math.max(0, Math.min(100, v));
      f.style.setProperty('--x', v + '%');
      if (!fromRange) r.value = v;
      var b = Math.round(v);
      r.setAttribute('aria-valuetext', b <= 2 ? 'After photo only' : b >= 98 ? 'Before photo only' : b + ' percent before photo, ' + (100 - b) + ' percent after photo');
      f.classList.toggle('is-b-hidden', v < 14);
      f.classList.toggle('is-a-hidden', v > 86);
    }
    function stopAnim() { touched = true; cancelAnimationFrame(anim); anim = 0; }
    r.addEventListener('input', function () { stopAnim(); set(Number(r.value), true); });
    r.addEventListener('keydown', function (e) {
      var v = Number(r.value), step = e.shiftKey ? 20 : 5, to = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') to = v + step;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') to = v - step;
      else if (e.key === 'PageUp') to = v + 20;
      else if (e.key === 'PageDown') to = v - 20;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = 100;
      if (to !== null) { e.preventDefault(); stopAnim(); set(to); }
    });
    /* pointer: tap jumps, sideways drag follows; vertical moves are left to the page scroll */
    var down = null;
    var pos = function (e) { var b = f.getBoundingClientRect(); return (e.clientX - b.left) / b.width * 100; };
    f.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      stopAnim();
      down = { x: e.clientX, y: e.clientY, id: e.pointerId, drag: e.pointerType === 'mouse' };
      if (down.drag) { f.setPointerCapture(e.pointerId); f.classList.add('is-drag'); set(pos(e)); e.preventDefault(); }
    });
    f.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== down.id) return;
      if (!down.drag) {
        var dx = Math.abs(e.clientX - down.x), dy = Math.abs(e.clientY - down.y);
        if (dx > 6 && dx > dy) { down.drag = true; try { f.setPointerCapture(e.pointerId); } catch (_) {} f.classList.add('is-drag'); }
        else if (dy > 8) { down = null; return; }
      }
      if (down.drag) set(pos(e));
    });
    var end = function (e) {
      if (!down) return;
      if (!down.drag && e.type === 'pointerup') set(pos(e));            /* a tap: jump there */
      down = null; f.classList.remove('is-drag');
    };
    f.addEventListener('pointerup', end);
    f.addEventListener('pointercancel', function () { down = null; f.classList.remove('is-drag'); });
    f.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function nudge() {
      if (REDUCE || touched || anim) return;
      var keys = [[0, 50], [380, 36], [820, 62], [1180, 50]], t0 = performance.now();
      var ease = function (t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
      (function step(now) {
        var t = now - t0, k = 1;
        while (k < keys.length - 1 && t > keys[k][0]) k++;
        var a = keys[k - 1], b = keys[k], u = Math.min(1, Math.max(0, (t - a[0]) / (b[0] - a[0])));
        set(a[1] + (b[1] - a[1]) * ease(u));
        if (t < keys[keys.length - 1][0] && !touched) anim = requestAnimationFrame(step); else { anim = 0; if (!touched) set(50); }
      })(t0);
    }
    set(Number(r.value) || 50);
    return { set: set, nudge: nudge, el: f };
  }

  function initSection(sec) {
    if (sec._bae) return sec._bae;
    var pairs = $$('[data-bae-pair]', sec);
    if (!pairs.length) return null;
    var frames = pairs.map(function (p) { return Frame($('[data-bae-frame]', p)); });
    var cur = 0, nudged = false;
    var pick = $('[data-bae-pick]', sec);
    function sel(i, focus) {
      cur = i;
      pairs.forEach(function (p, k) { p.hidden = k !== i; });
      if (pick) $$('[role="radio"]', pick).forEach(function (x, k) { x.setAttribute('aria-checked', k === i ? 'true' : 'false'); x.tabIndex = k === i ? 0 : -1; if (k === i && focus) x.focus(); });
    }
    if (pick) {
      var radios = $$('[role="radio"]', pick);
      radios.forEach(function (rb, k) {
        rb.addEventListener('click', function () { sel(k); });
        rb.addEventListener('keydown', function (e) {
          var n = radios.length, j = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (k + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (k - 1 + n) % n;
          else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = n - 1;
          if (j !== null) { e.preventDefault(); sel(j, true); }
        });
      });
    }
    if ('IntersectionObserver' in window && !REDUCE) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !nudged) { nudged = true; frames[cur].nudge(); io.disconnect(); } });
      }, { threshold: 0.6 });
      io.observe(frames[0].el);
    }
    sec._bae = { select: sel, frames: frames };
    return sec._bae;
  }

  function init(root) { return $$('[data-bae]', root || document).map(initSection); }
  window.gvbBeforeAfter = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* theme editor: selecting a pair's block shows that pair */
  document.addEventListener('shopify:block:select', function (e) {
    var p = e.target.closest && e.target.closest('[data-bae-pair]'), sec = p && p.closest('[data-bae]');
    if (!sec) return;
    var api = initSection(sec), k = Array.prototype.indexOf.call(sec.querySelectorAll('[data-bae-pair]'), p);
    if (api && k > -1) api.select(k);
  });
})();

